import { BREADCRUMB_NAMES } from '../../helpers/constant'
import translate from '../../i18n'
import styles from './nav-bar.module.less'
import { PageHeader } from '@ant-design/pro-components'
import { Breadcrumb } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

interface IProps {
  title: string
}

const NavBar = (props: IProps) => {
  const location = useLocation()
  const [breadcrumbItems, setBreadcrumbItems] = useState<any>()

  useEffect(() => {
    const extraBreadcrumbItems = BREADCRUMB_NAMES()
      .filter(item => location.pathname.match(item.regexp))
      .map(item => {
        const matchPath = location.pathname.match(item.regexp)
        const path = matchPath ? matchPath[0] : ''
        return {
          title: <Link to={path}>{item.title}</Link>,
        }
      })

    const tempBreadcrumbItems = [
      {
        title: <Link to="/">{translate('navBar.home')}</Link>,
      },
    ].concat(extraBreadcrumbItems)

    setBreadcrumbItems(tempBreadcrumbItems)
  }, [location.pathname])

  return (
    <PageHeader
      className={styles['page-header']}
      breadcrumbRender={() => <Breadcrumb items={breadcrumbItems}>{breadcrumbItems}</Breadcrumb>}
      title={props.title}
    ></PageHeader>
  )
}

export default NavBar
